module.exports = __webpack_public_path__ + "media/images/icons/equally-1542f356f625f65a6e3bdc91a6161510.svg";